<template>
    <modal>
        <template v-slot:header>
            <h3 class="modal-title">
                Betaalspecificatie details
            </h3>
        </template>
        <template v-slot:body>
        <div style="padding: 5px; padding-top: 0; max-height: calc(100vh - 200px); overflow-y: auto;">
            <div v-if="isModalLoading" class="text-center">
                Laden...
            </div>
            <div v-else-if="modalData">
                <div class="table-responsive">
                    <table class="table">
                        <thead class="font-weight-bold">
                            <tr>
                                <th>Verzorger</th>
                                <th>Kind</th>
                                <th>IBAN</th>
                                <th>Periode</th>
                                <th>Bedrag</th>
                                <th>Vergoedingsoverzicht</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, keyRow) in modalData.flatMap(payout => payout.rows)" :key="keyRow">
                                <td>{{ row.isInvoiceLine ? row.invoiceLineDescription : row.carerFullName }}</td>
                                <td>{{ !row.isInvoiceLine ? row.childFullName : '' }}</td>
                                <td>{{ row.ibanGastouder }}</td>
                                <td>{{ row.period }}</td>
                                <td>{{ parseFloat(row.amount).toLocaleString("nl-NL", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                                <td>{{ row.number }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-else>
                Geen gegevens gevonden voor deze betaalspecificatie.
            </div>
        </div>
        </template>
        <template v-slot:footer>
            <div>
                <button class="btn btn-outline-info" @click="this.$emit('closeModal')">Sluiten</button>
            </div>
        </template>
    </modal>
</template>
<script>
import Modal from "../../../components/Modal.vue";

export default {
    name: 'PaymentSpecificationsModal',
    components: {
        Modal
    },
    props: {
        idEuroCollect: null,
    },
    data() {
        return {
            modalData: null,
            isModalLoading: false,
        }
    },
    mounted() {
        this.fetchModalData();
    },
    methods: {
        fetchModalData() {
            this.isModalLoading = true;
            this.$store.commit('REGISTER_ACTIVE_REQUEST')
            this.$request
                .get(`/payout-details/${this.idEuroCollect}`)
                .then((response) => {
                    this.$store.commit('REMOVE_ACTIVE_REQUEST')
                    if (response) {
                        this.modalData = response.payouts;
                    }
                    this.isModalLoading = false
                });
        },
        handleOpenModal() {
            this.showModal = true;
            this.fetchModalData(this.idEuroCollect);
        },
    }
}
</script>